import React from 'react';
import PropTypes from 'prop-types';
import styles from '../css/DrugInfoSection.module.css';

const DrugInfoSection = ({ title, content }) => {
  return (
    <div className={styles.section}>
      <h3 className={styles.sectionTitle}>{title}</h3>
      <div className={styles.sectionContent}>
        <p>{content}</p>
      </div>
    </div>
  );
};

DrugInfoSection.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

export default DrugInfoSection;
